<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon color="error">fa-user-slash</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Delete Customer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout>
                <p>
                  <strong>Are you sure you want to delete this customer?</strong><br />
                  Deleting a Customer is a permanent, irrevocable action
                </p>
                <v-spacer></v-spacer>
                <v-btn dark color="error" @click="confirmedDelete"
                  ><v-icon class="mr-1">fa-times-circle</v-icon> Delete</v-btn
                >
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'close-customer-dialog',
  props: ['show', 'customer'],
  data: () => ({}),
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['deleteCustomer', 'addNotification']),
    closeDialog() {
      this.dialog = false;
    },
    confirmedDelete() {
      this.deleteCustomer(this.customer.id).then(() => {
        this.addNotification({
          text: `${this.customer.name} deleted`
        });
        this.dialog = false;
        this.$router.push('/customers');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
